import { createFileRoute, redirect } from '@tanstack/react-router'

/** `/settings/booking` opens the Booking map (C-05, Frontend §6.1). */
export const Route = createFileRoute('/_authed/clinics/$clinicId/settings/booking/')({
  beforeLoad: ({ params }) => {
    redirect({ to: '/clinics/$clinicId/settings/booking/map', params, replace: true, throw: true })
  },
})
